<template>
  <span
    :class="[{ 'adjust-position': bar.width < 58 }, bar.labelClassColor, bar.labelClassText]"
    :style="{ width: `${bar.width}px` }"
  >
    {{ bar.label }}
  </span>
</template>

<script>
export default {
  props: {
    bar: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.adjust-position {
  white-space: nowrap;
}
</style>
